import React, { memo, ReactNode } from 'react';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
interface TabPanelProps {
  /** The value of the tab this panel corresponds to */
  value: string;
  /** The currently active tab value */
  activeTab: string;
  /** Panel content */
  children: ReactNode;
  /** Additional CSS class */
  className?: string;
  /** Data ID for testing */
  dataId?: string;
  /** Whether to keep the panel mounted when inactive to preserve the inner content state */
  keepMounted?: boolean;
}
const PanelContainer = /*#__PURE__*/styled('div')({
  name: "PanelContainer",
  class: "p1ejk4wa",
  propsAsIs: false
});
const TabPanelComponent = ({
  value,
  activeTab,
  children,
  className,
  dataId,
  keepMounted = false
}: TabPanelProps) => {
  const isActive = activeTab === value;
  return <PanelContainer className={cx(className, isActive && 'isActive', keepMounted && 'keepMounted')} role="tabpanel" aria-labelledby={`tab-${value}`} id={`tabpanel-${value}`} data-id={dataId}>
      {(isActive || keepMounted) && children}
    </PanelContainer>;
};
export const TabPanel = memo(TabPanelComponent);

require("./TabPanel.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./TabPanel.tsx");